
const newModel = () => {
    return {
        hoatdongDulichId: null,
        nam: null,
        vanhoaDiemDuLichId: null,
        tenVanhoaDiemDuLich: null,
        luotkhachTrongnam: null,
        doanhThu: null,
        ghiChu: null,
        
        enabled: null,
        enabledDisplay: null,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null
    }
}

const newFEModel = () => {
    return {
        hoatdongDulichId: null,
        nam: null,
        vanhoaDiemDuLichId: null,
        luotkhachTrongnam: null,
        doanhThu: null,
        ghiChu: null,
        enabled: true,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null
    }
}

const fromJson = (item) => {
    return {
        hoatdongDulichId: item.hoatdongDulichId,
        nam: item.nam,
        vanhoaDiemDuLichId: item.vanhoaDiemDuLichId,
        tenVanhoaDiemDuLich: item.tenVanhoaDiemDuLich,
        luotkhachTrongnam: item.luotkhachTrongnam,
        doanhThu: item.doanhThu,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted
    }
}

const parseModeltoFEModel = (item) => {
    return {
        hoatdongDulichId: item.hoatdongDulichId,
        nam: item.nam,
        vanhoaDiemDuLichId: item.vanhoaDiemDuLichId,
        tenVanhoaDiemDuLich: item.tenVanhoaDiemDuLich,
        luotkhachTrongnam: item.luotkhachTrongnam,
        doanhThu: item.doanhThu,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted
    }
}

const errors = () => {
    return {
        hoatdongDulichId: null,
        nam: null,
        vanhoaDiemDuLichId: null,
        luotkhachTrongnam: null,
        doanhThu: null,
        ghiChu: null,
        enabled: null,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        nam: null,
        vanhoaDiemDuLichId: null,
        enabled: null,
    }
}

const newSearchModel = () => {
    return {
        nam: null,
        vanhoaDiemDuLichId: null,
        enabled: null,
    }
}


export const hoatDongDuLichModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    newPagingSearchModel,
    newSearchModel,
    fromJson,
    errors,
}


